import React from 'react';
import fr from 'facet-rest';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs, testAttr } from 'Helpers/Testing';
import { followRelationship } from 'Helpers/Affordances';
import { useSnackbarContext } from 'Context/SnackbarContext';

export const OtherMFAButton = ({ mfaType, setAuthCollection }) => {
  const { resource } = useMetaLayoutContext();
  const workingRef = React.useRef(false);
  const { displayErrorMessage } = useSnackbarContext();

  if (mfaType !== 'sms' && mfaType !== 'totp') {
    return null;
  }

  const relationshipLink = mfaType === 'sms' ? fr.relationships.mfaPreferenceSms.name : fr.relationships.mfaPreferenceTotp.name;
  return resource.withRelationship(relationshipLink, (rel) => {
    const onClick = async () => {
      if (workingRef.current === true) {
        return;
      }

      try {
        workingRef.current = true;
        const coll = await followRelationship(rel);
        setAuthCollection(coll);
      } catch (err) {
        displayErrorMessage(err, err.errors);
      }

      workingRef.current = false;
    };

    return (
      <FDSecondaryActionButton
        icon={mfaType === 'sms' ? 'authnMethodSms' : 'authnMethodTotp'}
        appearance={'minor'}
        onClick={onClick}
        {...dataAttrs('switch-auth-factor', {
          [testAttr.dataValue]: mfaType,
        })}
        label={rel.meta('prompt')}
      />
    );
  }, () => null);
};

OtherMFAButton.propTypes = {
  setAuthCollection: PropTypes.func.isRequired,
  mfaType: PropTypes.oneOf(['sms', 'totp']).isRequired,
};
